import {ofType, combineEpics} from 'redux-observable';
import {map, mergeMap} from 'rxjs/operators';
import {logon, startAPI, finishApi} from 'redux/appAction';

import store from '../app/store';
import knowService from '../api/know/knowService';
import {
  RDX_KNOW_DATA_FETCH,
  getKnowDataDone,
  RDX_KNOW_DATA_SAVE,
  saveKnowDataDone,
  saveKnowDataErr,
  RDX_KNOW_RESULT_FETCH,
  RDX_KNOW_NEXT_STEP_FETCH,
  getKnowResultDone,
  RDX_KNOW_DATA_UPDATE,
  updateKnowDataDone,
  updateKnowDataErr,
  RDX_KNOW_UPLOAD_CERTIFICATE,
  uploadCertificateDone,
  uploadCertificateErr,
  getKnowParams,
  getKnowNextStep,
  RDX_KNOW_SCORES_FETCH,
  getKnowScoresDone,
  getDataErrorInfo,
  endSpinnerAPI,
  updateKnowDataErrSpinner,
  saveKnowDataErrSpinner,
  updateKnowDataDoneSpinner,
  RDX_KNOW_DATA_SAVE_SPINNER,
  RDX_KNOW_NEXT_STEP_FETCH_SPINNER,
  RDX_KNOW_DATA_UPDATE_SPINNER,
  RDX_KNOW_SCORES_FETCH_SPINNER,
  RDX_KNOW_DATA_FETCH_SPINNER,
  saveKnowDataDoneSpinner,
  getKnowScoresDoneSpinner,
  getDataErrorInfoSpinner,
  getKnowDataDoneSpinner,
  updateKnowData,
} from '../redux/knowAction';
import {
  buildGetKnowRequest,
  convertGetKnowResponse,
  buildSaveKnowRequest,
  buildUpdateKnowRequest,
  getKnowQuestionResult,
  // buildUploadFileRequest,
  getknowNextStep,
} from '../convertor/knowConvertor';
import history from '../app/history';

const knowFetchDataEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_DATA_FETCH),
    mergeMap((action) =>
      knowService.getKnowData(buildGetKnowRequest(action)).pipe(
        map((wResponse) => {
          if (wResponse && wResponse.status === 200) {
            // normal response, go normal flow
            const data = convertGetKnowResponse(wResponse, action);
            return getKnowDataDone(data);
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            // error response , go error flow
            let errorInfo = '';
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
              }
            } else {
              errorInfo = [{code: wResponse.status}];
            }
            history.push('/mistake');
            store.dispatch(finishApi());
            return getDataErrorInfo(errorInfo);
          }
        }),
      ),
    ),
  );

//loading spinner fetch data
const knowFetchDataSpinnerEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_DATA_FETCH_SPINNER),
    mergeMap((action) =>
      knowService.getKnowDataSpinner(buildGetKnowRequest(action)).pipe(
        map((wResponse) => {
          if (wResponse && wResponse.status === 200) {
            // normal response, go normal flow
            const data = convertGetKnowResponse(wResponse, action);
            store.dispatch(endSpinnerAPI());
            return getKnowDataDoneSpinner(data);
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            // error response , go error flow
            let errorInfo = '';
            store.dispatch(endSpinnerAPI());
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
              }
            } else {
              errorInfo = [{code: wResponse.status}];
            }
            history.push('/mistake');
            store.dispatch(finishApi());
            return getDataErrorInfoSpinner(errorInfo);
          }
        }),
      ),
    ),
  );

const knowResultDataEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_RESULT_FETCH),
    mergeMap((action) =>
      knowService.getKnowResult(action).pipe(
        map((wResponse) => {
          if (wResponse && wResponse.status === 200) {
            // normal response, go normal flow
            const data = convertGetKnowResponse(wResponse);
            if (action.params === 'thanks') {
              const knowResult = getKnowQuestionResult(data);
              return getKnowResultDone(knowResult);
            } else {
              return getKnowResultDone(data);
            }
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            // error response , go error flow
            let errorInfo = '';
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
              }
            } else {
              errorInfo = [{code: wResponse.status}];
            }
            history.push('/mistake');
            store.dispatch(finishApi());
            return getDataErrorInfo(errorInfo);
          }
        }),
      ),
    ),
  );
//loading page
const knowNextStepEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_NEXT_STEP_FETCH),
    mergeMap((action) =>
      knowService.getKnowResult(action).pipe(
        map((wResponse) => {
          if (wResponse) {
            if (wResponse.status === 200) {
              const nextStepResult = getknowNextStep(wResponse);
              return getKnowParams(
                nextStepResult.nextUrl,
                nextStepResult.groupCodes,
                wResponse.response,
              );
            } else if (wResponse.status === 403) {
              return logon('token');
            } else {
              // error response , go error flow
              let errorInfo = '';
              if (wResponse.status === 500) {
                if (wResponse.response && wResponse.response.errorInfo) {
                  errorInfo = wResponse.response.errorInfo;
                } else {
                  errorInfo = [{code: wResponse.status}];
                }
              } else {
                errorInfo = [{code: wResponse.status}];
              }
              history.push('/mistake');
              store.dispatch(finishApi());
              return getDataErrorInfo(errorInfo);
            }
          }
        }),
      ),
    ),
  );

//loading spinner button
const knowNextSpinnerStepEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_NEXT_STEP_FETCH_SPINNER),
    mergeMap((action) =>
      knowService.getKnowResultSpinner(action).pipe(
        map((wResponse) => {
          if (wResponse) {
            if (wResponse.status === 200) {
              const nextStepResult = getknowNextStep(wResponse);
              return getKnowParams(
                nextStepResult.nextUrl,
                nextStepResult.groupCodes,
                wResponse.response,
              );
            } else if (wResponse.status === 403) {
              store.dispatch(endSpinnerAPI());
              return logon('token');
            } else {
              // error response , go error flow
              store.dispatch(endSpinnerAPI());
              let errorInfo = '';
              if (wResponse.status === 500) {
                if (wResponse.response && wResponse.response.errorInfo) {
                  errorInfo = wResponse.response.errorInfo;
                } else {
                  errorInfo = [{code: wResponse.status}];
                }
              } else {
                errorInfo = [{code: wResponse.status}];
              }
              history.push('/mistake');
              store.dispatch(finishApi());
              return getDataErrorInfoSpinner(errorInfo);
            }
          }
        }),
      ),
    ),
  );

//Save questionnaire by POST method
const knowSaveDataEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_DATA_SAVE),
    mergeMap((action) =>
      knowService.saveKnowData(buildSaveKnowRequest(action.data)).pipe(
        map((wResponse) => {
          console.log('wResponse=========', wResponse);
          if (wResponse && wResponse.status === 201) {
            //avoid loading
            store.dispatch(startAPI());
            //according params redirect experience page or knowledge page
            if (action.data === 'experience') {
              return getKnowNextStep('accreditation');
            }
            if (action.data === 'equities') {
              return getKnowNextStep('accreditation');
            }
            return saveKnowDataDone(wResponse.status);
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            // error response , go error flow
            let errorInfo = '';
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
              }
            } else {
              errorInfo = [{code: wResponse.status}];
            }
            return saveKnowDataErr(wResponse.status, errorInfo);
          }
        }),
      ),
    ),
  );

//loading spinner for save data
const knowSaveDataSpinnerEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_DATA_SAVE_SPINNER),
    mergeMap((action) =>
      knowService.saveKnowDataSpinner(buildSaveKnowRequest(action.data)).pipe(
        map((wResponse) => {
          console.log('wResponse=========', wResponse);
          if (wResponse && wResponse.status === 201) {
            // normal response, go normal flow
            return saveKnowDataDoneSpinner(wResponse.status);
          } else if (wResponse.status === 403) {
            store.dispatch(endSpinnerAPI());
            return logon('token');
          } else {
            store.dispatch(endSpinnerAPI());
            // error response , go error flow
            let errorInfo = '';
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
                history.push('/mistake');
              }
            } else {
              errorInfo = [{code: wResponse.status}];
              history.push('/mistake');
            }
            return saveKnowDataErrSpinner(wResponse.status, errorInfo);
          }
        }),
      ),
    ),
  );

const knowScoresEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_SCORES_FETCH),
    mergeMap((action) =>
      knowService.getKnowScores(action.data).pipe(
        map((wResponse) => {
          if (wResponse && wResponse.status === 201) {
            return getKnowScoresDone(wResponse.response.response);
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            // error response , go error flow
            let errorInfo = '';
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
              }
            } else {
              errorInfo = [{code: wResponse.status}];
            }
            history.push('/mistake');
            return getDataErrorInfo(errorInfo);
          }
        }),
      ),
    ),
  );

//loading spinner for calcualte score
const knowScoresSpinnerEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_SCORES_FETCH_SPINNER),
    mergeMap((action) =>
      knowService.getKnowScoresSpinner(action.data).pipe(
        map((wResponse) => {
          if (wResponse && wResponse.status === 201) {
            return getKnowScoresDoneSpinner(wResponse.response.response);
          } else if (wResponse.status === 403) {
            store.dispatch(endSpinnerAPI());
            return logon('token');
          } else {
            store.dispatch(endSpinnerAPI());
            // error response , go error flow
            let errorInfo = '';
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
              }
            } else {
              errorInfo = [{code: wResponse.status}];
            }
            history.push('/mistake');
            return getDataErrorInfo(errorInfo);
          }
        }),
      ),
    ),
  );

const knowUpdateDataEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_DATA_UPDATE),
    mergeMap((action) =>
      knowService.updateKnowData(buildUpdateKnowRequest(action.data)).pipe(
        map((wResponse) => {
          console.log('wResponse=========', wResponse);
          if (wResponse && wResponse.status === 201) {
            return updateKnowDataDone(wResponse.status);
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            // error response , go error flow
            let errorInfo = '';
            console.log('wResponse===========', wResponse);
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
                history.push('/mistake');
              }
            } else {
              errorInfo = [{code: wResponse.status}];
              history.push('/mistake');
            }
            return updateKnowDataErr(wResponse.status, errorInfo);
          }
        }),
      ),
    ),
  );

//loading spinner for update data
const knowUpdateDataSpinnerEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_DATA_UPDATE_SPINNER),
    mergeMap((action) =>
      knowService.updateKnowDataSpinner(buildUpdateKnowRequest(action.data)).pipe(
        map((wResponse) => {
          console.log('wResponse=========', wResponse);
          if (wResponse && wResponse.status === 201) {
            return updateKnowDataDoneSpinner(wResponse.status);
          } else if (wResponse.status === 403) {
            store.dispatch(endSpinnerAPI());
            return logon('token');
          } else {
            store.dispatch(endSpinnerAPI());
            // error response , go error flow
            let errorInfo = '';
            console.log('wResponse===========', wResponse);
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
                history.push('/mistake');
              }
            } else {
              errorInfo = [{code: wResponse.status}];
              history.push('/mistake');
            }
            return updateKnowDataErrSpinner(wResponse.status, errorInfo);
          }
        }),
      ),
    ),
  );

const uploadCertificateFileEpic = (action$) =>
  action$.pipe(
    ofType(RDX_KNOW_UPLOAD_CERTIFICATE),
    mergeMap((action) =>
      knowService.uploadCertificateFile(action.data.formData).pipe(
        map((wResponse) => {
          if (wResponse && wResponse.status === 201) {
            let updateParams = action.data.questionParams;
            updateParams.push(wResponse.response[0]);
            updateParams.push(wResponse.response[1]);
            store.dispatch(updateKnowData(updateParams));
            return uploadCertificateDone(wResponse.response);
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            let errorInfo = '';
            console.log('wResponse===========', wResponse);
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
              }
            } else {
              errorInfo = [{code: wResponse.status}];
            }
            return uploadCertificateErr(wResponse.status, errorInfo);
          }
        }),
      ),
    ),
  );

const knowEpic = combineEpics(
  knowFetchDataEpic,
  knowSaveDataEpic,
  knowResultDataEpic,
  knowNextStepEpic,
  knowUpdateDataEpic,
  uploadCertificateFileEpic,
  knowScoresEpic,
  knowNextSpinnerStepEpic,
  knowSaveDataSpinnerEpic,
  knowScoresSpinnerEpic,
  knowUpdateDataSpinnerEpic,
  knowFetchDataSpinnerEpic,
);

export default knowEpic;
